module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-CN":{"omitted_count":"等 {0} 件商品","write_review":"去写评价"}}')
  delete Component.options._Ctor
}
